import { useSuspenseQuery } from "@tanstack/react-query";
import { type LendingApiClient, useApi } from "@lending/lib/api";
import { STANDARD_QUERY_CACHE_CONFIG } from "@lending/lib/queryConfig";

function getCreditCardProductsQueryOptions($api: LendingApiClient) {
  return $api.queryOptions(
    "get",
    "/v2/lending/credit_card_products/",
    {},
    STANDARD_QUERY_CACHE_CONFIG
  );
}

function useGetCreditCardProductsQuery() {
  const $api = useApi();
  const query = useSuspenseQuery(getCreditCardProductsQueryOptions($api));

  return {
    creditCardProductsData: query.data,
    hasMultipleProducts: query.data.count > 1,
  };
}

export { useGetCreditCardProductsQuery, getCreditCardProductsQueryOptions };
